import { useQuery } from "@tanstack/react-query";
import type { GroupRecord } from "@tg/shared";
import { api, getAppToken } from "./api";

/** Load ALL active+inactive groups by paging the cursor into one array (filtered client-side). */
export function useAllGroups() {
  return useQuery({
    queryKey: ["groups", "all"],
    enabled: !!getAppToken(),
    staleTime: 60_000,
    queryFn: async (): Promise<GroupRecord[]> => {
      const all: GroupRecord[] = [];
      let cursor: string | null = null;
      let guard = 0;
      do {
        const qs = new URLSearchParams({ activeOnly: "false", limit: "200" });
        if (cursor) qs.set("cursor", cursor);
        const page = await api.groups(qs.toString());
        all.push(...page.items);
        cursor = page.nextCursor;
      } while (cursor && guard++ < 1000);
      return all;
    },
  });
}

export function useTags() {
  return useQuery({
    queryKey: ["tags"],
    enabled: !!getAppToken(),
    queryFn: api.tags,
  });
}

export function useCacheStatus() {
  return useQuery({
    queryKey: ["cacheStatus"],
    enabled: !!getAppToken(),
    queryFn: api.cacheStatus,
  });
}

export function useDraft() {
  return useQuery({
    queryKey: ["draft"],
    enabled: !!getAppToken(),
    queryFn: api.getDraft,
  });
}
